module.exports = __webpack_public_path__ + "static/fonts/NanumSquareB.e850eb6.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/NanumSquare/NanumSquareB.ttf
// module id = HXKb
// module chunks = 1